import { washLanguageData } from '@/utils/wash.js'
import { getNodeByFlag } from '../../common/controlBar/controlBarDialog/metaComponent/utils'
const washData = (node) => {
  try {
    switch (node._type) {
      case 'home_product_five':
        washLanguageData(node, 'VIEW MORE', 'name')
        getNodeByFlag(node,'home-product-slide').list[1].list[0].list[2].flag = 'main_button'
        break
    }
  } catch (err) {
    console.log('err--', err)
  }
}
export { washData }
